<!-- Start a new Breakers page - new format is a landing page -->
<!-- structure header - main - footer  -->
<!-- subtitles -> font-family: 'Bebas Neue', cursive; -->
<!-- title, body -> font-family: 'Prata', serif; -->
<app-header></app-header>


<!-- vamos precisar alterar a home, para isso, creio que vamos ter que mudar todo o layout de pagina -->
<!-- vou deixar os layouts antigos de lado por enquanto para focarmos no novo... -->
  <main>
    
    <app-apresentation></app-apresentation>
    <app-sinopse></app-sinopse>
    <app-preview></app-preview>
    <app-autor></app-autor>
    <app-qrcode></app-qrcode>
    <app-depoimentos></app-depoimentos>
    <app-compra></app-compra>
  </main>

<app-footer></app-footer>
